export const emailsStringToArray = (emailsStr?: string): string[] => {
	if (!emailsStr?.trim()) {
		return [];
	}

	return emailsStr.split(',').map((email) => email.trim());
};
